import { ReactNode } from "react";
import { Tooltip } from "antd";
import { StyledItemButton, StyledItemLink } from "./FinaSidebar.style";

/**
 * A row of the rail — a destination, or an action.
 *
 * Most rows navigate, so most rows are links. Depositing and withdrawing are
 * not places: they are short forms that open over whatever the reader is
 * looking at, so those rows are buttons. Both wear the same chrome, because
 * the difference is in what happens and not in how the row looks.
 */
const MenuItem = ({
  content,
  icon,
  $isActive,
  to,
  onClick,
  collapse,
}: {
  content: string;
  icon: ReactNode;
  $isActive?: boolean;
  to?: string;
  /** Present instead of `to` on a row that opens something in place. */
  onClick?: () => void;
  collapse?: boolean;
}) => {
  const link = onClick ? (
    <StyledItemButton
      type="button"
      $isActive={$isActive}
      $collapse={collapse}
      onClick={onClick}
    >
      {icon}
      <span>{content}</span>
    </StyledItemButton>
  ) : (
    <StyledItemLink $isActive={$isActive} $collapse={collapse} to={to}>
      {icon}
      <span>{content}</span>
    </StyledItemLink>
  );

  /* Collapsed, the label is hidden and the icon is the only thing naming the
     destination, so the name has to be reachable some other way. */
  return collapse ? (
    <Tooltip title={content} placement="right" mouseEnterDelay={0.2}>
      {link}
    </Tooltip>
  ) : (
    link
  );
};
export { MenuItem as default };
